import React from 'react';

const ApiKeyCredentialsFormModal = React.lazy(() => import('../components/FormModal'));
const apiKeyCredentialsModalRegistry = {
    core_apiKeyCredentialsId: ApiKeyCredentialsFormModal
};
export default apiKeyCredentialsModalRegistry;
